module.exports = __webpack_public_path__ + "static/charleston-b02417665ee7032ece4c0a3f1f6b8b86.png";